import React from "react";

const TimeTrackingSVG = () => {
  return (
    <svg
      width="116"
      height="118"
      viewBox="0 0 116 118"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M115.993 59.7168C115.335 92.1206 58.0337 117.047 58.0337 117.047C58.0337 117.047 2.05008 93.9915 0.0741846 59.7168C-1.90171 25.4422 34.0584 0.953125 58.0287 0.953125C81.9989 0.953125 116.652 27.313 115.993 59.7168Z"
        fill="#FCEDFB"
      />
      <path
        d="M73.6214 71.868V40.3223H31V68.2816C31 70.2624 32.5757 71.868 34.5194 71.868H73.6214Z"
        fill="#E692E6"
      />
      <path
        d="M36.3024 62.6569H35.6914C33.1004 62.6569 31 64.7974 31 67.4377V40.7808C31 38.1404 33.1004 36 35.6914 36H36.3024V62.6569Z"
        fill="#E692E6"
      />
      <path
        d="M69.9417 67.8854H38.1914V44.2998H69.9417L69.9417 67.8854ZM38.4566 67.6152H69.6765V44.57H38.4566V67.6152Z"
        fill="white"
      />
      <path
        d="M69.9441 51.1363H60.1602V44.2998H69.9441V51.1363ZM60.4253 50.866H69.6789V44.57H60.4253V50.866Z"
        fill="white"
      />
      <path
        d="M69.9441 54.4137H60.1602V50.8662H69.9441V54.4137ZM60.4253 54.1435H69.6789V51.1365H60.4253V54.1435Z"
        fill="white"
      />
      <path
        d="M69.9441 57.691H60.1602V54.1436H69.9441V57.691ZM60.4253 57.4208H69.6789V54.4138H60.4253V57.4208Z"
        fill="white"
      />
      <path
        d="M55.1317 47.4072H39.7891V48.5654H55.1317V47.4072Z"
        fill="white"
      />
      <path
        d="M55.1473 51.1709H39.8047V52.3291H55.1473V51.1709Z"
        fill="white"
      />
      <path
        d="M55.1669 54.9355H39.8242V56.0937H55.1669V54.9355Z"
        fill="white"
      />
      <path
        d="M55.1864 58.6992H39.8438V59.8574H55.1864V58.6992Z"
        fill="white"
      />
      <path d="M55.2098 62.4629H39.8672V63.621H55.2098V62.4629Z" fill="white" />
      <path
        d="M71.0079 79.2327C77.2384 79.2327 82.2892 74.0857 82.2892 67.7365C82.2892 61.3873 77.2384 56.2402 71.0079 56.2402C64.7774 56.2402 59.7266 61.3873 59.7266 67.7365C59.7266 74.0857 64.7774 79.2327 71.0079 79.2327Z"
        fill="white"
      />
      <path
        d="M78.0015 74.8685C81.8663 70.93 81.8663 64.5446 78.0015 60.6061C74.1366 56.6676 67.8705 56.6676 64.0057 60.6061C60.1409 64.5446 60.1409 70.9301 64.0057 74.8685C67.8705 78.807 74.1366 78.807 78.0015 74.8685Z"
        fill="#E692E6"
      />
      <path
        d="M73.0204 70.9941V73.4349C73.0204 74.5084 72.1664 75.3786 71.113 75.3786H70.8332C69.7798 75.3786 68.9258 74.5084 68.9258 73.4349V70.9941H73.0204Z"
        fill="#DADADA"
      />
      <path
        d="M74.3974 66.7244C74.8607 66.0578 75.1812 65.1052 75.1812 64.2344C75.1812 63.2701 74.8485 62.3828 74.2908 61.6792C74.2495 61.6271 74.2069 61.576 74.1632 61.5259C74.032 61.3757 73.89 61.235 73.7385 61.1049C73.688 61.0616 73.6365 61.0194 73.5839 60.9784C73.5576 60.958 73.5311 60.9378 73.5043 60.9179C72.8078 60.4015 71.9432 60.0957 71.0066 60.0957C70.0699 60.0957 69.2054 60.4015 68.5089 60.9179C68.4821 60.9378 68.4556 60.9579 68.4292 60.9784C68.3767 61.0194 68.3251 61.0616 68.2746 61.1049C68.1232 61.235 67.9812 61.3757 67.85 61.5259C67.8062 61.576 67.7637 61.6271 67.7224 61.6792C67.1646 62.3828 66.832 63.2701 66.832 64.2344C66.832 65.1052 67.1524 66.0578 67.6158 66.7244C67.6435 66.7731 67.6709 66.8221 67.698 66.8717C68.0422 67.7625 68.4449 69.7249 68.5439 70.6844C68.5492 70.7868 68.554 70.8918 68.5583 71C68.561 71 68.5636 71 68.5662 71C68.5662 71.0005 68.5663 71.001 68.5663 71.0015C68.7777 71.0014 68.9891 71.0013 69.2005 71.0013C69.8025 71.0011 70.4046 71.0009 71.0067 71.0007C71.6088 71.0009 72.2108 71.0011 72.8129 71.0013C73.0243 71.0013 73.2357 71.0014 73.447 71.0015C73.447 71.001 73.4471 71.0005 73.4471 71C73.4497 71 73.4524 71 73.4551 71C73.4593 70.8918 73.4642 70.7868 73.4694 70.6844C73.5684 69.7249 73.9711 67.7625 74.3153 66.8717C74.3423 66.8221 74.3697 66.7731 74.3974 66.7244Z"
        fill="#B11489"
      />
      <path
        d="M74.2915 61.6782C74.2502 61.6261 74.2076 61.575 74.1639 61.5249C74.0327 61.3747 73.8907 61.234 73.7392 61.1039C73.6887 61.0606 73.6372 61.0184 73.5846 60.9775C73.5583 60.957 73.5318 60.9368 73.505 60.9169C72.8085 60.4005 71.9439 60.0947 71.0072 60.0947C70.8187 60.0947 70.6331 60.1073 70.4512 60.1314C71.1577 60.2314 71.8072 60.5068 72.3534 60.9117C72.3802 60.9316 72.4067 60.9517 72.4329 60.9722C72.4855 61.0132 72.5371 61.0554 72.5876 61.0987C72.739 61.2288 72.881 61.3695 73.0122 61.5197C73.0559 61.5698 73.0985 61.6209 73.1398 61.673C73.6975 62.3766 74.0302 63.2639 74.0302 64.2282C74.0302 65.099 73.7098 66.0516 73.2465 66.7182C73.2187 66.7669 73.1913 66.8159 73.1642 66.8655C72.82 67.7563 72.4173 69.7187 72.3184 70.6782C72.3131 70.7806 72.3083 70.8856 72.304 70.9938C72.3013 70.9938 72.2986 70.9938 72.296 70.9938C72.296 70.9943 72.2959 70.9948 72.2959 70.9953C72.0846 70.9952 71.8732 70.9951 71.6618 70.9951C71.0597 70.9949 70.4576 70.9947 69.8556 70.9945C69.4232 70.9947 68.9909 70.9948 68.5586 70.9949C68.5586 70.9963 68.5587 70.9977 68.5588 70.9991C68.5614 70.9991 68.5641 70.9991 68.5667 70.9991C68.5667 70.9995 68.5667 71 68.5667 71.0005C68.7781 71.0005 68.9895 71.0004 69.2009 71.0003C69.803 71.0001 70.405 70.9999 71.0071 70.9998C71.6092 70.9999 72.2113 71.0001 72.8133 71.0003C73.0247 71.0003 73.2361 71.0004 73.4475 71.0005C73.4475 71 73.4475 70.9995 73.4475 70.9991C73.4502 70.9991 73.4528 70.9991 73.4555 70.9991C73.4598 70.8908 73.4646 70.7858 73.4699 70.6834C73.5688 69.724 73.9716 67.7615 74.3158 66.8707C74.3429 66.8212 74.3702 66.7722 74.398 66.7234C74.8613 66.0568 75.1817 65.1042 75.1817 64.2334C75.1819 63.2691 74.8492 62.3819 74.2915 61.6782Z"
        fill="#B11489"
      />
      <path
        d="M72.9909 72.4001L68.9705 71.7361C68.8731 71.7201 68.8068 71.6265 68.8226 71.5271L68.8269 71.5008C68.8426 71.4014 68.9345 71.3339 69.032 71.35L73.0524 72.014C73.1498 72.03 73.2161 72.1236 73.2003 72.223L73.196 72.2493C73.1803 72.3487 73.0884 72.4161 72.9909 72.4001Z"
        fill="#788FA1"
      />
      <path
        d="M72.9909 73.3454L68.9705 72.6815C68.8731 72.6654 68.8068 72.5718 68.8226 72.4724L68.8269 72.4461C68.8426 72.3467 68.9345 72.2792 69.032 72.2953L73.0524 72.9593C73.1498 72.9753 73.2161 73.0689 73.2003 73.1683L73.196 73.1947C73.1803 73.294 73.0884 73.3615 72.9909 73.3454Z"
        fill="#788FA1"
      />
      <path
        d="M72.9909 74.2907L68.9705 73.6268C68.8731 73.6107 68.8068 73.5171 68.8226 73.4178L68.8269 73.3914C68.8426 73.292 68.9345 73.2245 69.032 73.2407L73.0524 73.9046C73.1498 73.9207 73.2161 74.0142 73.2003 74.1136L73.196 74.14C73.1803 74.2393 73.0884 74.3068 72.9909 74.2907Z"
        fill="#788FA1"
      />
    </svg>
  );
};

export default TimeTrackingSVG;
